var components
try {
  components = {
    uniList: function () {
      return import(
        /* webpackChunkName: "uni_modules/uni-list/components/uni-list/uni-list" */ "@/uni_modules/uni-list/components/uni-list/uni-list.vue"
      )
    },
    uniListItem: function () {
      return import(
        /* webpackChunkName: "uni_modules/uni-list/components/uni-list-item/uni-list-item" */ "@/uni_modules/uni-list/components/uni-list-item/uni-list-item.vue"
      )
    },
    mpHtml: function () {
      return import(
        /* webpackChunkName: "uni_modules/mp-html/components/mp-html/mp-html" */ "@/uni_modules/mp-html/components/mp-html/mp-html.vue"
      )
    },
    uDivider: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-divider/u-divider" */ "uview-ui/components/u-divider/u-divider.vue"
      )
    },
    uGap: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-gap/u-gap" */ "uview-ui/components/u-gap/u-gap.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }